import { render, staticRenderFns } from "./list.vue?vue&type=template&id=d46bb85a&scoped=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"
import style0 from "./list.vue?vue&type=style&index=0&id=d46bb85a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46bb85a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d46bb85a')) {
      api.createRecord('d46bb85a', component.options)
    } else {
      api.reload('d46bb85a', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=d46bb85a&scoped=true", function () {
      api.rerender('d46bb85a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policies/list.vue"
export default component.exports